import React from 'react';
import styled, { css } from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import { formatPrice } from '@catalogo/core-helpers/price';
import { ISummary } from '../helpers/interfaces';

export const Summary: React.FC<ISummary> = props => {
  const { totalProducts, totalValue, onClickBuyButton } = props;

  if (totalProducts === 1) {
    return (
      <BuyTogetherSummary>
        <SummaryInfo>
          <Text>escolha os produtos pra comprar junto</Text>
        </SummaryInfo>
        <ButtonUI disabled={true}>comprar junto</ButtonUI>
      </BuyTogetherSummary>
    );
  }

  return (
    <BuyTogetherSummary>
      <SummaryInfo>
        <p>
          comprar {totalProducts} produtos por <PriceText>R$ {formatPrice(totalValue)}</PriceText>
        </p>
      </SummaryInfo>
      <ButtonUI disabled={false} onClick={onClickBuyButton}>
        comprar junto
      </ButtonUI>
    </BuyTogetherSummary>
  );
};

const BuyTogetherSummary = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.grey.dark};
  width: 100%;
  flex-direction: column;
`;

const SummaryInfo = styled.div`
  min-height: 33px;
  flex-direction: column;
`;

const Text = styled.p`
  margin-bottom: 0;
  text-align: center;
`;

const PriceText = styled.span`
  margin-bottom: 19px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  font-weight: bold;
  color: ${({ theme }) => theme.black};
`;

const ButtonUI = styled(Nav)`
  font-size: 16px;
  font-weight: 700;
  border-radius: 8px;
  padding: 12px 48px;
  text-transform: lowercase;

  ${({ theme, disabled }) => css`
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    color: ${disabled ? theme.grey.light : theme.primaryColor};
    border: 2px solid ${disabled ? theme.grey.light : theme.primaryColor};
  `}
`;

export default Summary;
